"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const constants_1 = require("../../constants/constants");
const eventConstants_1 = require("../../constants/eventConstants");
const screenConstants_1 = require("../../constants/screenConstants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const typesConstants_1 = require("../../constants/typesConstants");
const ticketGridContainer_1 = __importDefault(require("../../components/ticketComponent/ticketGridContainer"));
const filterTicket_1 = __importDefault(require("../../components/filterTickets/filterTicket"));
const ticketConstants_1 = require("./ticketConstants");
const ticketForm_1 = __importDefault(require("../../components/ticketComponent/ticketForm"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const ticketSlice_1 = require("./ticketSlice");
const paginatedMessageComponent_1 = __importDefault(require("../../components/messageComponent/paginatedMessageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const tab_1 = __importDefault(require("../../components/tab/tab"));
const navigationButton_1 = __importDefault(require("../../components/button/navigationButton"));
const modal_1 = __importDefault(require("../../components/modal/modal"));
const ticketTable_1 = __importDefault(require("../../components/ticketComponent/ticketTable"));
const Ticketing = () => {
    const dispatch = useAppDispatch_1.default();
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_2);
    const navigator = native_1.useNavigation();
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const { officer, tickets, loadingStatus, currentPage } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
        tickets: state.ticket.tickets,
        loadingStatus: state.ticket.loadingStatus,
        currentPage: state.ticket.currentPage || 1,
    }));
    const [queryParams, setQueryParams] = react_1.useState({
        status: ticketConstants_1.OPEN,
        // Exclude reporter_type filter for quality analysts to show all tickets
        ...(officer.officer_type !== typesConstants_1.OFFICER_TYPES_QUALITY_ANALYST && { reporter_type: officer.officer_type }),
    });
    const [modalVisible, setModalVisible] = react_1.useState(false);
    const [gridLayout, setGridLayout] = react_1.useState(false);
    const onPageChange = (page) => {
        dispatch(ticketSlice_1.resetTicketState());
        dispatch(ticketSlice_1.getTickets({ ...queryParams, page }));
    };
    const showTicketDetails = ({ ticket }) => {
        dispatch(ticketSlice_1.setSelectedTicket(ticket));
        dispatch(ticketSlice_1.getComments({ ticket_id: ticket.id }));
        navigator.navigate(screenConstants_1.TICKET_DETAIL_SCREEN, { ticket_id: ticket.id });
    };
    native_1.useFocusEffect(react_1.useCallback(() => {
        // Fetch by default open tickets related to the logged officer's category
        dispatch(ticketSlice_1.getTickets({ ...queryParams, page: currentPage }));
    }, []));
    const ticketsListContent = gridLayout ? (react_1.default.createElement(ticketGridContainer_1.default, { onTicketPress: showTicketDetails, onPageChange: onPageChange })) : (react_1.default.createElement(ticketTable_1.default, { onTicketPress: showTicketDetails, onPageChange: onPageChange }));
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignSpaceBetween] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Ticket" })),
                react_1.default.createElement(navigationButton_1.default, { onPress: () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), title: "Dashboard", event: eventConstants_1.NAVIGATE_HOME_BUTTON })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignSpaceBetween, styles_1.default.flexDirectionRow, styles_1.default.marginTen] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexDirectionRow] },
                    react_1.default.createElement(react_native_paper_1.Button, { buttonColor: colors_1.default.BLUE, textColor: colors_1.default.WHITE, icon: "newspaper-plus", onPress: () => setModalVisible(true), style: styles_1.default.marginRightTen }, `Create Ticket `)),
                react_1.default.createElement(react_native_1.View, { style: [
                        styles_1.default.flexDirectionRow,
                        styles_1.default.alignCenterCenter,
                        styles_1.default.alignSpaceBetween,
                    ] },
                    react_1.default.createElement(tab_1.default, { isActive: !gridLayout, text: "List", icon: "view-list", onPress: () => setGridLayout(false) }),
                    react_1.default.createElement(tab_1.default, { isActive: gridLayout, text: "Grid", icon: "view-grid", onPress: () => setGridLayout(true) }))),
            react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexFive },
                    loadingStatus === typesConstants_1.PENDING_STATUS ? (react_1.default.createElement(spinner_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexDirectionRow },
                            react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexFour }, loadingStatus === typesConstants_1.SUCCEEDED_STATUS && tickets.length === 0 ? (react_1.default.createElement(paginatedMessageComponent_1.default, { message: "No Tickets Found.", color: colors_1.default.BLUE, icon: free_solid_svg_icons_1.faSadTear })) : (ticketsListContent)),
                            react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexOne },
                                react_1.default.createElement(filterTicket_1.default, { queryParams: queryParams, setQueryParams: setQueryParams }))))),
                    react_1.default.createElement(modal_1.default, { title: "Create Ticket", visible: modalVisible, hideModal: () => setModalVisible(false), containerStyle: styles_1.default.modelFormTop },
                        react_1.default.createElement(react_native_1.View, { style: [isDesktop && styles_1.default.flexDirectionRow] },
                            react_1.default.createElement(ticketForm_1.default, { ticket: null }))))))));
};
exports.default = Ticketing;
